import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { ApiToken, ApiTokenList, CreateApiTokenInput, CreatedApiToken } from "@msc/shared";
import { api } from "../lib/api.js";

/**
 * Die eigene Liste und die Admin-Liste sind zwei Mengen desselben Bestands;
 * ein Widerruf trifft beide, darum invalidiert jeder Schreibzugriff `all`.
 */
export const apiTokenKeys = {
  all: ["apiTokens"] as const,
  own: () => [...apiTokenKeys.all, "own"] as const,
  admin: () => [...apiTokenKeys.all, "admin"] as const,
};

export function useApiTokens(admin: boolean) {
  return useQuery<ApiToken[]>({
    queryKey: admin ? apiTokenKeys.admin() : apiTokenKeys.own(),
    queryFn: async () =>
      (await api.get<ApiTokenList>(admin ? "/api-tokens" : "/me/api-tokens")).items,
  });
}

export function useCreateApiToken() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateApiTokenInput) =>
      api.post<CreatedApiToken>("/me/api-tokens", input),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: apiTokenKeys.all }),
  });
}

export function useRevokeApiToken(admin: boolean) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      api.delete<{ ok: true }>(admin ? `/api-tokens/${id}` : `/me/api-tokens/${id}`),
    onSettled: () => void queryClient.invalidateQueries({ queryKey: apiTokenKeys.all }),
  });
}
